import { settingsTextareaFields } from '../../konstanter/adminConfig';

function AdminSettingsFormSection({ handleSettingsSubmit, setSettingsForm, settingsForm }) {
  return (
    <section className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.9)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
      <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Forsideinnstillinger</p>
      <h2 className="font-serif text-2xl font-semibold text-[#163127]">Hero, highlights og nøkkeltall</h2>
      <form className="mt-5 grid gap-4" onSubmit={handleSettingsSubmit}>
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Merkenavn</span>
          <input
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setSettingsForm((current) => ({ ...current, brandName: event.target.value }))}
            type="text"
            value={settingsForm.brandName}
          />
        </label>
        {settingsTextareaFields.map((config) => (
          <label className="grid gap-2" key={config.field}>
            <span className="text-sm font-semibold text-[#355046]">{config.label}</span>
            <textarea
              className={`${config.rowsClassName} rounded-2xl border border-[#1832281f] bg-white px-4 py-3`}
              onChange={(event) =>
                setSettingsForm((current) => ({
                  ...current,
                  [config.field]: config.transform(event.target.value),
                }))
              }
              value={config.format(settingsForm[config.field])}
            />
          </label>
        ))}
        <button className="inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-6 font-semibold text-[#f9f5ee]" type="submit">
          Lagre innstillinger
        </button>
      </form>
    </section>
  );
}

export default AdminSettingsFormSection;